import React, { useState, useEffect } from 'react';
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { Link } from 'react-router-dom';
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
import {
    BreadcrumbPage
} from "../../shared";
import { textAlign } from '@mui/system';
const useStyles = makeStyles((theme) => ({
    justifyContentBetween: {
        justifyContent: "space-between!important",
    },
    boxLayout: {
      backgroundColor: "#fff",
      boxShadow: "0px 0px 2px 1px rgb(0 0 0 / 12%)",
      borderRadius: 8,
    },
    tableLayout: {
      border: 0,
      boxShadow: "0 0 0 0 !important",
    },
    txtInput: {
      "& input": {
        padding: "4px 8px",
        fontWeight: 600,
      },
      "& fieldset": {},
    },
    breadcrumbBox: {
      borderTopLeftRadius: "8px",
      borderTopRightRadius: "8px",
    },
    btnStyle1: {
      borderRadius: "25px",
      border: "2px solid #ff4717",
      boxShadow: "2px 2px 4px 2px #dadada",
      color: "#ffffff",
      background: "#ff4717 !important",
      textTransform: "capitalize",
      padding: "4px 22px",
      //marginLeft: "200px",
    }, 
    /* btnStyle1: {
        borderRadius: "25px",
        border: "2px solid #ff4717",
        boxShadow: "2px 2px 4px 2px #dadada",
        color: "#ff4717",
        background: "##ff4717 !important",
        textTransform: "capitalize",
        padding: "4px 22px",
        marginLeft: "75px",
      }, */
    btnStyle2: {
      borderRadius: "25px",
      border: "2px solid #1A1A31",
      boxShadow: "2px 2px 4px 2px #dadada",
      color: "#ffffff",
      background: "#1A1A31 !important",
      textTransform: "capitalize",
      padding: "4px 22px",
      marginLeft: "75px",
    },
    btnStyle3: {
      borderRadius: "12px",
      border: "2px solid #1A1A31",
      boxShadow: "2px 2px 4px 2px #dadada",
      color: "#ffffff",
      background: "#1A1A31 !important",
      textTransform: "capitalize",
      padding: "8px 11px",
     left: "50%",
      margin: "0px auto !important",
      marginLeft: "-120px !important",
      width: "240px",
    },
    moveinput: {
      marginRight: "100px",
    },
    link: {
      textTransform: "capitalize",
      //color: "#ff4717 ",
      fontSize: "20px",
      textDecoration: "none",
      background: "none",
      border: "none",
      // marginLeft: "5px",
      "padding-right": "27px",
      // width: "12px",
      // height: "5px",
      '&:hover': {
        "text-decoration": "underline",
       
        background: "none",
      }
  
    },
  
  
  }));

function Analytics() {
    const BreadcrumbList = [{ name: "Analytics", url: "" }];
    const classes = useStyles();






    return (
        <div>
            <Box component="main" px={3} display="flex">
                <Grid container>
                    <Grid item xs={12} sm={12}>
                        <Box display="dlock">
                            <BreadcrumbPage rows={BreadcrumbList} />
                        </Box>
                    </Grid>
                </Grid>
            </Box>

            <Box component="main" p={3} pb={2} display="flex">
                <Grid container>
                
                    <Grid item xs={12} sm={10} md={6}>
                        <Box
                            component="div"
                            display="block"
                            style={{ marginTop: 2  }}
                            pr={1}
                        >
                           <h3 style={{color: "#ff4717 "}}>Analytics</h3>
                            <p  style={{textAlign:"justify"}}>
                                With the largest and most complete database of marine fuel quality results available in the market 
                                today, we provide our customers with a digital portfolio of standard and customised data & analytics 
                                services. Whether it is anticipating fuel quality trends before bunkering in a certain port or knowing 
                                which fuel suppliers deliver the highest quality fuel, we have a solution that’s right for you.
                            </p>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={10} md={3} className="dashboard-right">
                    <Grid item xs={12} sm={12} md={12}>
                        <Box component="div" display="block" pl={1}>
                        
                        <img style={{width: "600px", height:"auto"}}src="/assets/images/Dataportfolio_1.jpg"  alt="DataPortfolio" />
                        
                        </Box>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={10} md={2}></Grid>
                </Grid>
            </Box>

            <Box component="main" p={3} pt={1} display="flex">
                <Grid container>
                    <Grid item xs={12} sm={12} md={6}>
                        <Box
                            component="div"
                            display="block"
                            style={{ marginTop: 2  }}
                            pr={1}
                        >
                            <h3 style={{color: "#ff4717"}}>Portstats</h3>
                            <p style={{textAlign:"justify"}}>PortStats is the name of the VPS data analytics platform, which allows us to create, manage and
                                distribute interactive dashboards for and to our customers. There are already several fuel- and lube 
                                quality monitoring apps available within the platform. By subscribing to the PortStats platform, users
                                gain the ability to utilize VPS’ global fuel quality data in real-time, meaning they can benchmark any 
                                fuel suppliers and ports on individual quality and quantity parameters.</p><br/>
                                <Grid container>
                                <Grid item xs={12} sm={12} md={6} className="analbtn">
                                <Button className={classes.btnStyle2} href="https://qlik.portstats.nl/azure/hub/" target="_blank">Log-in to VPS PortStats <br/>
                                (existing subscribers)</Button>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6}>
                                <Button className={classes.btnStyle1} href="https://www.vpsveritas.com/PortStats-Request-demo.html" target="_blank">Request PortStats <br/>
                                Online Demonstration</Button>
                                </Grid>
                                </Grid><br/>
                                <h3 style={{color: "#ff4717"}}>Fuel Insights</h3>
                            <p style={{textAlign:"justify"}}>Marine Fuel Insights is our subscription-based data report that provides subscribers with in-depth
                             analyses about the properties and availability of VLSFOs (very low sulphur fuel oils) and other future 
                            fuels. Released on a monthly basis, Marine Fuel Insights is aimed at improving transparency in the 
                            market when it comes to marine fuel quality.</p><br/>
                            <Grid container>
                                <Grid item xs={12} sm={12} md={6} className="analbtn">
                            <Button className={classes.btnStyle2}  href="https://cms.vpsveritas.com/sites/default/files/2022-04/Fuel%20Insights%20%2328%20-%20Executive%20Summary.pdf" target="_blank">Download <br/>
                                Executive Summary(PDF)</Button>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6}>
                                <Button className={classes.btnStyle1}  href="https://www.vpsveritas.com/VLSFO-Insights-Subscription.html" target="_blank">Request Fuel Insights <br/>
                                Commercial Proposal</Button>
                                </Grid>
                                </Grid>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} className="dashboard-right">
                        <Box component="div" display="block" pl={1} style={{ marginTop:"50px" }}>
                        <img style={{width:"100%", height:"auto"}} src="/assets/images/VPSportstatus.jpg"  alt="VPSportstatus" />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={10} md={2}></Grid>
                </Grid>

            </Box>
            {/* <Box component="main" p={3} pt={1} display="flex">
                <Grid container>
                    <Grid item xs={12} sm={12} md={8}>
                        <Box
                            component="div"
                            display="block"
                            style={{ marginTop: 2, cursor: "pointer" }}
                            pr={1}
                        >
                            <h2>Fuel Insights</h2>
                            <p>Marine Fuel Insights is our subscription-based data report that provides subscribers with in-depth<br />
                             analyses about the properties and availability of VLSFOs (very low sulphur fuel oils) and other future <br />
                            fuels. Released on a monthly basis, Marine Fuel Insights is aimed at improving transparency in the <br />
                            market when it comes to marine fuel quality.</p>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={12} md={8} className="dashboard-right">
                        <Box component="div" display="block" pl={1}>

                        </Box>
                    </Grid>
                </Grid>

            </Box> */}
            <Box component="main" p={3} pt={1} display="flex">
                <Grid container>
                    <Grid item xs={12} sm={12} md={6}>
                        <Box
                            component="div"
                            display="block"
                            style={{ marginTop: 2  }}
                            pr={1}
                        >
                            <h3 style={{color: "#ff4717"}}>Custom Data Services</h3>
                            <p style={{textAlign:"justify"}}>With VPS Data Services, we don’t just offer the best data, but we are also able to provide you with
                            advice from our in-house technical experts. Whether it’s on fuel quality, separator performance or 
                            lube oil condition monitoring, we have the knowledge in-house to support you on specific problems.<br /></p>
 
                            <p style={{textAlign:"justify"}}>Our customised data reports offer in-depth views into the technical side of marine fuels and lube oils,
                            for any organisation that needs expert advice backed by data and facts. Contact us now with a 
                            description of your requirement and we will contact you to discuss a matching solution.</p><br/>
                            <Grid item xs={12} sm={12} md={12}>
                            <Button className={classes.btnStyle3}  href="mailto:dataservices@v-p-s.com?subject=Data request">Contact VPS Account  Manager</Button>
                                </Grid>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} className="dashboard-right">
                        <Box component="div" display="block" pl={1} style={{marginTop:"50px"}} >
                        <img style={{width: "100%",height:"auto"}} src="/assets/images/spfolio.jpg"  alt="spfolio" />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={12} md={2} className="dashboard-right"></Grid>
                </Grid>

            </Box>

        </div>


    );
}

export default Analytics;